const APP_BASE_URL = process.env.REACT_APP_APP_BASE_URL;
const API_SCHOOL_URL = process.env.REACT_APP_API_SCHOOL_URL;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export { API_BASE_URL, API_SCHOOL_URL, APP_BASE_URL };
